import React, { useEffect, useRef, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { Spinner } from 'react-bootstrap';
import markerIconPng from 'leaflet/dist/images/marker-icon.png';
import 'leaflet/dist/leaflet.css';

const LocationMap = ({ coordinates, setShow }) => {

  const { latitude, longitude, time} = coordinates;

  const [locationName, setLocationName] = useState('');
  const [loading, setLoading] = useState(false);
  const mapRef = useRef(null);
  const position = [latitude, longitude];

  const markerIcon = new L.Icon({
    iconUrl: markerIconPng,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
  });

  useEffect(() => {
    if(latitude && longitude){
      fetchLocationDetails();
    }
    if (mapRef.current) {
      setTimeout(() => {
        mapRef.current.invalidateSize();
      }, 100);
    }
  }, []);

  const fetchLocationDetails = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
      );
      const data = await response.json();
      if (data && data.display_name) {
        setLocationName(data.display_name);
      } else {
        setLocationName('Location details not available.');
      }
    } catch (error) {
      setLocationName('Failed to fetch location details.');
    }
    setLoading(false);
  };

  return (
    <div style={{ height: '450px', width: '100%', position: 'relative' }}>
      <div className='d-flex justify-content-between align-items-baseline'>
      <p><span className='fw-bold'>Time -</span> {time}</p>
      <button
        className="btn text-primary border-0 bg-transparent"
        style={{ zIndex: 1000 }}
        onClick={() => setShow()}
      >
        <i className="fa-solid fa-arrow-left"></i> Back
      </button>
      </div>
      <MapContainer
        center={position}
        zoom={16}
        scrollWheelZoom={true}
        style={{ height: '100%', width: '100%' }}
        whenCreated={(mapInstance) => {
          mapRef.current = mapInstance;
        }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker position={position} icon={markerIcon}>
        <Popup>
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <>
                    <strong>Location:</strong> <br />
                    {locationName || "N/A"}
                  </>
                )}
              </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default LocationMap;
